import { CodeSnippetComponent } from './code-snippet/code-snippet.component';

export {
	CodeSnippetComponent,
};

export const Components = [
	CodeSnippetComponent,
];
